import { render } from "./sf-typeahead.vue?vue&type=template&id=5495ee1f"
import script from "./sf-typeahead.vue?vue&type=script&lang=js"
export * from "./sf-typeahead.vue?vue&type=script&lang=js"

import "./sf-typeahead.vue?vue&type=style&index=0&id=5495ee1f&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__